module.exports = __webpack_public_path__ + "965a8d12c1b922e2d6a13c07e5166c09.svg";